<template>
  <div>


    <el-menu
      :default-active="activeIndex2"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#fff"
      text-color="#1b2b39"
      active-text-color="#337ab7" style="margin-bottom: 20px"
    >


      <el-menu-item index="2" style="float: right">
        <el-dropdown>
          <span class="el-dropdown-link">
            {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <a href="#/Person">
              <el-dropdown-item>
                <i class="iconfont icon-icon">个人信息 </i>
              </el-dropdown-item>
            </a>

            <a href="https://www.zjhylab.com/passport/#/login">
              <el-dropdown-item>
                <i class="iconfont icon-tuichu3"> 退出</i>
              </el-dropdown-item>
            </a>
          </el-dropdown-menu>
        </el-dropdown>
      </el-menu-item>
      <el-menu-item index="1" style="float: right" class="hovercompany">
        <a href="https://cloud.hzjly.cn/company/#/company/index" >
          <img width="24" style="position: relative;" :src="companyplaninfo[0].logo">
          {{companyname}}
          <div class="showcompany" @click.prevent='goto'>
            <div>
              <p style="color:#d78f52;font-size: 20px">{{companyplaninfo[0].planname}}</p>
              <p style="font-size: 14px;color: #57585a" v-show="companyplaninfo[0].endtime!=''">将于
                {{companyplaninfo[0].endtime.substring(0,11)}} 到期</p>
              <p style="font-size: 14px;color: #57585a" v-show="companyplaninfo[0].endtime==''">续费升级 点亮图标</p>
            </div>
            <div style="margin-left: auto;">
              <el-button type="warning"  v-show="companyplaninfo[0].endtime!=''">立即续费</el-button>
              <el-button type="warning" v-show="companyplaninfo[0].endtime==''" >立即升级</el-button>
            </div>
          </div>
        </a>
      </el-menu-item>



      <a href="/#/Index"><img src="../assets/logo2.png"
                              style="margin: 15px 0 0 15px"/></a>

     <div style="margin-top: -40px;margin-left: 330px"> <el-button  @click="$router.back(-1)">返回</el-button></div>
    </el-menu>




    <el-dialog
      title="转让"
      :visible.sync="Transferdialog"
      width="50%"
    >
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="Transferdialog = false">转让</el-button>
    </span>
    </el-dialog>






  </div>


</template>

<script>

  export default {
    name: "Header",
    created() {




    },
    data() {
      return {
        userName: '',
        musicopen: true,
        activeIndex2: '0',
        companyplaninfo: [
          {
            logo: 'https://static.hzjly.cn/img/v1.png',
            planname: '标准会员',
            endtime: '',
          }
        ],
        devInfo:[],
        companyname: '',
        balance: '',
        Transferdialog: false,
        Companydialog: false,

        form: {
          Code: '',
        },
      }
    },
    mounted() {
      let _this=this;


      //获取title
      this.$axios.get("https://passport.hzjly.cn/api/User/GetUserInfo?guid=", {
        params: {}
      })
        .then(res => {
          var data = res.data;
          data = JSON.parse(data);
          localStorage.setItem('userInfo', JSON.stringify(data));
          this.userName = data.results.result.username;
          this.companyname = data.results.result.companyname;
          if (data.results.result.companyplaninfo.length == 0) {
            this.companyplaninfo = [{logo: "https://static.hzjly.cn/img/v1.png", planname: "标准会员", endtime: ''}]
          } else {
            this.companyplaninfo = data.results.result.companyplaninfo;
          }
        })
        .catch(err => {

        });

    },
    methods: {
      handleSelect(key, keyPath) {
        // console.log(key, keyPath);
        // this.$router.push({path: key});
      },
      goto(e) {
        window.location.href="https://vip.hzjly.cn/#/Index"
      },
    }
  }
</script>

<style scoped>
  .hovercompany:hover .showcompany {
    display: flex;
  }

  .showcompany button {
    height: 30px;
    line-height: 0;
    background-color: #e2b455;
    border-radius: 15px;
    padding: 12px 16px;
  }

  .showcompany {
    z-index: 999;
    -moz-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);
    -webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    font: 12px/1.5 Microsoft Yahei, Arial, Tahoma, sans-serif, Hiragino Sans GB;
    position: absolute;
    width: 266px;
    height: 46px;
    right: 0;
    display: none;
    justify-items: center;
    align-items: center;
    background-color: white;
    color: black;
    padding: 12px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
  }

  .showcompany p {
    line-height: 26px;
  }

  .el-menu-item:hover {
    background: #F6FAF9 !important;
    color: #247af0 !important;
  }

  .el-menu-item:hover i {
    color: #247af0 !important;
  }

  .el-menu-item:hover .el-dropdown-link {
    color: #247af0 !important;
  }

  .el-submenu__title {
    background: #F6FAF9 !important;
    color: #247af0 !important;
  }


  .el-dropdown-menu {
    margin-top: 5px !important;
  }


  /*.el-popper >>> .popper__arrow::after {*/
  /*border-width: 0px !important;*/
  /*}*/

  /*.el-popper[x-placement^=bottom] >>> .popper__arrow:after {*/
  /*border-bottom-color: blue;*/
  /*border-width: 0px !important;*/
  /*}*/
  /*.el-popper[x-placement^=bottom] >>> .popper__arrow {*/
  /*border-bottom-color: blue;*/
  /*border-width: 0px !important;*/
  /*}*/
  /*.back{*/
  /* !/ margin-top: -200px;*!*!*/
  /*  margin-left: 30px;*/
  /*  text-align: center;*/
  /*  !*padding-top: 10px;*!*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/Header.vue